<template>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <p v-if="question.Mandatory" v-html="question.QuestionText+'<font color=red> *</font>'"></p>
        <p v-else v-html="question.QuestionText"></p>
      </v-flex>
      <v-flex xs12 sm6 class="align-end">
        <v-checkbox
          :rules="[!this.question.Mandatory || this.question.AnswerNo != null || this.$t('Field is required')]"
          class="mt-0"
          v-model="question.AnswerNoBool"
          :color="'primary'"
          :indeterminate="question.AnswerNo == null">
        </v-checkbox>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import rules from '@/core/mixins/common-rules'

export default {
  mixins: [rules],
  props: ['question'],
  watch: {
    'question.AnswerNoBool': function (newValue) {
      // We need to update this so indeterminate works properly
      this.question.AnswerNo = newValue
    }
  }

}
</script>

<style>

</style>
